import { __awaiter } from "tslib";
import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment';
import stepByStepValidate from '@/services/_helpers/stepByStepValidate';
import SERVICES from '@/constants/services';
import { LevelName } from '../../../popupChunks/types';
import { getPassportUrl } from '@/utils/other';
export default Vue.extend({
    props: {
        slotData: {
            type: Object,
            required: true
        }
    },
    name: 'walletSecret2FAPopupChunk',
    data: () => ({
        step: 1,
        hasWhiteListSecret: true,
        whitelistAddressIsLoading: false,
        userWalletAddress: null,
        form: {
            fields: {
                secretCode: {
                    valid: false,
                    value: '',
                    type: 'password',
                    rules: [
                        (v) => Boolean(v.length) || 'Поле обязательно'
                    ],
                    isLoading: false,
                    exist: false,
                    responseErrors: []
                },
                smsCode: {
                    valid: false,
                    value: '',
                    codeSendError: false,
                    codeIsSent: false,
                    codeSentBefore: false,
                    sending: false,
                    isLoading: false,
                    retryTimeout: 60,
                    retries: 3,
                    letRetry: false,
                    rules: [
                        (v) => Boolean(v.length) || 'Поле обязательно',
                        (v) => v.length === SERVICES.CODE_LENGTH || `Код должен состоять из ${SERVICES.CODE_LENGTH} символов`
                    ],
                    responseErrors: []
                }
            }
        },
        GAForm: {
            fields: {
                GACode: {
                    valid: false,
                    responseErrors: [],
                    isLoading: false,
                    value: '',
                    rules: [
                        (v) => Boolean(v) || 'Поле обязательно',
                        (v) => v.length === SERVICES.CODE_LENGTH || `${SERVICES.CODE_LENGTH}-значный код`
                    ]
                }
            }
        }
    }),
    computed: Object.assign(Object.assign({}, mapGetters('user', ['getUserData'])), { getUserWalletAddress() {
            if (this.userWalletAddress)
                return this.userWalletAddress;
            if (this.slotData.summaryWithdrawData.walletData.address)
                return this.slotData.summaryWithdrawData.walletData.address;
            return this.slotData.summaryWithdrawData.walletData.blurredAddress;
        } }),
    watch: {
        'form.fields.smsCode.retryTimeout'(v) {
            const vm = this;
            if (v > 0) {
                setTimeout(() => {
                    vm.form.fields.smsCode.retryTimeout = v - 1;
                }, 1000);
            }
            else
                vm.form.fields.smsCode.letRetry = true;
        },
        'form.fields.secretCode.value'() {
            this.form.fields.secretCode.responseErrors = [];
        },
        'form.fields.smsCode.valid'(v) {
            if (v && this.form.fields.smsCode.value.length > 0)
                this.validateSecondStep();
        },
        'form.fields.smsCode.value'() {
            this.form.fields.smsCode.responseErrors = [];
        },
        'GAForm.fields.GACode.valid'(v) {
            if (v && this.GAForm.fields.GACode.value.length > 0)
                this.validateSecondStep();
        },
        'GAForm.fields.GACode.value'() {
            this.GAForm.fields.GACode.responseErrors = [];
        }
    },
    methods: {
        hasntAccessHandler(method) {
            const hasCurrentMethod = this.getUserData.currentAccessRepairMethods.includes(method);
            const methodName = method === 'ga' ? 'Google Authenticator' : 'телефона';
            const vm = this;
            if (hasCurrentMethod) {
                this.$store.dispatch('popupModule/openPopup', {
                    type: 'confirmPopup',
                    letDefaultClose: true,
                    title: 'Предупреждение',
                    content: `В данный момент идет восстановление ${methodName}, установленного как метод 2FA для подтверждения операций в Личном кабинете. Вы сможете выполнить операцию после завершения восстановления.`,
                    actions: [
                        {
                            title: 'Хорошо',
                            isAccent: true,
                            callback() { vm.$store.commit('popupModule/setClosed'); }
                        }
                    ]
                });
                return;
            }
            const isBasic = this.getUserData.verificationRights.levelName === LevelName.basic;
            const convertedMethodName = method === 'ga' ? 'Google Authenticator' : 'телефон';
            if (isBasic) {
                vm.$store.dispatch('popupModule/openPopup', {
                    type: 'confirmPopup',
                    letDefaultClose: false,
                    title: `Восстановление ${methodName}`,
                    content: `Чтобы восстановить ${convertedMethodName}, нужно пройти расширенную верификацию аккаунта.`,
                    actions: [
                        {
                            title: 'К разделу',
                            isAccent: true,
                            callback() {
                                vm.$store.commit('popupModule/setClosed');
                                window.location.href = getPassportUrl('/id/', { withAcceptor: true });
                            }
                        },
                        {
                            title: 'Позже',
                            isAccent: false,
                            callback() {
                                vm.$store.commit('popupModule/setClosed');
                            }
                        }
                    ]
                });
                return;
            }
            this.$router.push({ name: 'AccessRepair', query: { secondFactor: method, an3K8QkkJb3Mzz: this.slotData.sessionId } });
        },
        checkWhitelistSecret() {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield this.services.mainService.checkWhitelistSecret(null);
                this.hasWhiteListSecret = response.data.walletSecret;
            });
        },
        toggleSecretAppear() {
            const vm = this;
            vm.form.fields.secretCode.type = vm.form.fields.secretCode.type === 'password' ? 'text' : 'password';
        },
        sendSMS() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.form.fields.smsCode.sending = true;
                vm.form.fields.smsCode.codeSentBefore = false;
                const response = yield vm.services.mainService.sendCode(vm.slotData.codes.sms.type);
                if (response.success) {
                    vm.form.fields.smsCode.sending = false;
                    vm.form.fields.smsCode.codeIsSent = true;
                    vm.form.fields.smsCode.letRetry = false;
                    vm.form.fields.smsCode.retryTimeout = moment(response.data.repeatAfter).diff(moment(), 'seconds');
                    vm.form.fields.smsCode.retries -= 1;
                    setTimeout(() => {
                        vm.form.fields.smsCode.retryTimeout -= 1;
                    }, 1000);
                }
                else {
                    vm.form.fields.smsCode.sending = false;
                    if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.repeatAfter) {
                        vm.form.fields.smsCode.codeSentBefore = true;
                        vm.form.fields.smsCode.codeIsSent = true;
                        vm.form.fields.smsCode.letRetry = false;
                        vm.form.fields.smsCode.retryTimeout = moment(response.data.repeatAfter).diff(moment(), 'seconds');
                        vm.form.fields.smsCode.retries -= 1;
                        setTimeout(() => {
                            vm.form.fields.smsCode.retryTimeout -= 1;
                        }, 1000);
                    }
                    else {
                        vm.form.fields.smsCode.codeSendError = true;
                        vm.form.fields.smsCode.letRetry = true;
                    }
                }
            });
        },
        validateFirstStep() {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.form.fields.secretCode.responseErrors = [];
                vm.form.fields.secretCode.isLoading = true;
                setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b;
                    const response = yield stepByStepValidate({
                        name: vm.slotData.name,
                        endpointName: vm.slotData.endpointName,
                        data: {
                            sessionId: vm.slotData.sessionId,
                            payload: { wallet_secret: vm.form.fields.secretCode.value }
                        },
                        steps: vm.slotData.steps
                    });
                    vm.form.fields.secretCode.isLoading = false;
                    if (response.success) {
                        this.form.fields.secretCode.exist = true;
                        const smsVerify = vm.getUserData.confirmation === 'sms';
                        if (smsVerify)
                            vm.sendSMS();
                        vm.whitelistAddressIsLoading = true;
                        const currentWalletWithAddressResponse = yield vm.services.mainService.getWhitelistWalletsWithAddresses({
                            walletSecret: vm.form.fields.secretCode.value
                        }, vm.slotData.summaryWithdrawData.walletData.id);
                        if (currentWalletWithAddressResponse.success && ((_b = (_a = currentWalletWithAddressResponse.data) === null || _a === void 0 ? void 0 : _a.wallets[0]) === null || _b === void 0 ? void 0 : _b.address)) {
                            vm.userWalletAddress = currentWalletWithAddressResponse.data.wallets[0].address;
                        }
                        vm.whitelistAddressIsLoading = false;
                    }
                    else {
                        vm.form.fields.secretCode.responseErrors = response.errors;
                    }
                }), 1000);
            });
        },
        validateFirstStepWithoutSecret() {
            this.step = 2;
            const smsVerify = this.getUserData.confirmation === 'sms';
            if (smsVerify)
                this.sendSMS();
        },
        validateSecondStep() {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                const smsVerify = vm.getUserData.confirmation === 'sms';
                if (smsVerify) {
                    vm.form.fields.smsCode.responseErrors = [];
                    vm.form.fields.smsCode.isLoading = true;
                }
                else {
                    vm.GAForm.fields.GACode.responseErrors = [];
                    vm.GAForm.fields.GACode.isLoading = true;
                }
                const code = smsVerify ? vm.form.fields.smsCode.value : vm.GAForm.fields.GACode.value;
                setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                    const response = yield stepByStepValidate({
                        name: vm.slotData.name,
                        endpointName: vm.slotData.endpointName,
                        data: {
                            sessionId: vm.slotData.sessionId,
                            payload: { [`${vm.getUserData.confirmation}`]: code }
                        },
                        steps: vm.slotData.steps
                    });
                    if (response.success) {
                        vm.$emit('onSuccess');
                        return;
                    }
                    if (smsVerify) {
                        vm.form.fields.smsCode.responseErrors = response.errors;
                        vm.form.fields.smsCode.isLoading = false;
                        return;
                    }
                    vm.GAForm.fields.GACode.responseErrors = response.errors;
                    vm.GAForm.fields.GACode.isLoading = false;
                }), 1000);
            });
        },
        handleCancel() {
            const vm = this;
            vm.$store.commit('popupModule/setClosed');
        }
    },
    created() {
        if (!this.slotData.secretConfirmed)
            this.checkWhitelistSecret();
    }
});
